import { css, styled } from 'styled-components';

export const Counter = styled.span<{ isDisabled?: boolean }>`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  vertical-align: middle;
  margin-left: 8px;
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      color: inherit;
    `}
`;
